import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'
import { errorHandler } from '@/utils/errorHandler'

export default {
    getUnfinishedShipmentsReportsShiftSummary(context, userId) {
        return axios
            .get(`/shipments/shipments-reports-shift-summaries?user_id=${userId}&status_id=1`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie raportów zbiorczych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    startShipmentReportingSession() {
        return axios
            .post('/shipments/shipments-reports-shift-summaries')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Rozpoczęcie sesji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    stopShipmentReportingSession({ commit }, { id, statusId }) {
        return axios
            .put(`/shipments/shipments-reports-shift-summaries/${id}`, {
                statusId
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zakończono pracę.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zakończenie sesji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createShipmentReport({ commit }, payload) {
        return axios
            .post('/shipments/shipments-reports', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rozpoczęto rejestrowanie czasu.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Rejestrowanie czasu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    finishShipmentReport({ commit }, {id, payload}) {
        return axios
            .put(`/shipments/shipments-reports/${id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zakończono rejestrowanie czasu.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zakończenie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrder(context, query) {
        return axios
            .get(`sendings/address${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wyszukanie zamówienia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateOrderAddress(context, payload) {
        return axios
            .patch(`/sendings/order-addresses/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja adresu nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getCouriers() {
        return axios
            .get('/carriers/carriers/dicts/carriers')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                errorHandler(error)
            })

    },
    updateCourier({ commit }, payload) {
        return axios
            .put(`/carriers/carriers/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Przewoźnik został zedytowany.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja przewoźnika nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getBoxesInfo(context, payload) {
        return axios
            .post('/sendings/boxes-info', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o kartonach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    recalculateUnitBox(context, payload) {
        return axios
            .post('/sendings/collecting-boxes', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja kartonów nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getGates({ commit }) {
        return axios
            .get('/sendings/gates/dicts/gates')
            .then(response => {
                commit('GET_GATES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie bramek nie powiodło się.')

                return Promise.reject(error)
            })

    },
    setGenerateEANLabels(context, payload) {
        return axios
            .post('/sendings/generate-ean-labels', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wydrukowanie etykiet nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setGenerateCustomLabels(context, payload) {
        return axios
            .post('/sendings/generate-custom-labels', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wydrukowanie etykiet nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setGenerateBillboardLabels(context, payload) {
        return axios
            .post('/sendings/generate-billboard-labels', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wydrukowanie etykiet nie powiodło się.')

                return Promise.reject(error)
            })
    },
    printSendingsLabels(context, payload) {
        return axios
            .post('/sendings/label', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie etykiet nie powiodło się.')

                return Promise.reject(error)
            })
    },
    reprintSendingsLabels(context, payload) {
        return axios
            .post('/sendings/reprint-label', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Ponowny wydruk etykiet nie powiódł się.')

                return Promise.reject(error)
            })
    },
    getPackage(context, packageNumber) {
        return axios
            .get(`/sendings/package/${packageNumber}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie paczki nie powiodło się.')

                return Promise.reject(error)
            })
    },
    printPackageLabels(context, payload) {
        return axios
            .post('/sendings/send-package', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie etykiet nie powiodło się.')

                return Promise.reject(error)
            })
    },
    reprintPackageLabels(context, payload) {
        return axios
            .post('/sendings/reprint-package-label', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Ponowny wydruk etykiet nie powiódł się.')

                return Promise.reject(error)
            })
    },
    getShippingLabelsPrintHistory({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_SHIPPING_LABELS_PRINT_HISTORY_REQUEST')

        return axios
            .get(`/sendings/label-print-history${paginate}${query}`)
            .then(response => {
                commit('GET_SHIPPING_LABELS_PRINT_HISTORY_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_SHIPPING_LABELS_PRINT_HISTORY_FAILURE')
                handleApiError(error, 'Pobranie historii wydruków etykiet nie powiodło się.')

                return Promise.reject(error)
            })
    },
    reviewAdditionalShipmentAction({ commit }, payload) {
        return axios
            .put(`/shipments/review-process-code-shipment-report/${payload.reportId}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zatwierdzanie czynności dodatkowej zostało zaktualizowane.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Zatwierdzanie czynności dodatkowej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setSendingsSettings({ commit }, data) {
        commit('SET_SENDINGS_SETTINGS', data)
    },
    setShippingLabelsPrintHistoryFilters({ commit }, filters) {
        commit('SET_SHIPPING_LABELS_PRINT_HISTORY_FILTERS', filters)
    },
    clearShippingLabelsPrintHistoryFilters({ commit }) {
        commit('CLEAR_SHIPPING_LABELS_PRINT_HISTORY_FILTERS')
    },
}